import React from 'react';
import { motion } from 'framer-motion';
type SectionProps = {
  id?: string;
  children: React.ReactNode;
  className?: string;
  bg?: string;
};
export function Section({
  id,
  children,
  className = '',
  bg = ''
}: SectionProps) {
  return <section id={id} className={`w-full px-5 py-16 sm:py-24 ${bg}`} data-id="element-215" data-mp="3ntytihks2w2e">
      <div className={`mx-auto max-w-5xl ${className}`} data-id="element-216" data-mp="3sssaijz9x57b">{children}</div>
    </section>;
}
const revealVariants = {
  hidden: {
    opacity: 0,
    y: 24
  },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.22, 1, 0.36, 1],
      delay: i * 0.06
    }
  })
};
export function Reveal({
  children,
  index = 0,
  className = ''
}: {
  children: React.ReactNode;
  index?: number;
  className?: string;
}) {
  return <motion.div variants={revealVariants} custom={index} initial="hidden" whileInView="visible" viewport={{
    once: true,
    margin: '-60px'
  }} className={className} data-id="element-217" data-mp="39vr3ktm5sv0q">
      {children}
    </motion.div>;
}
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  align = 'center'
}: {
  eyebrow?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  align?: 'center' | 'left';
}) {
  const alignClasses = align === 'center' ? 'text-center mx-auto' : 'text-left';
  return <div className={`max-w-2xl ${alignClasses}`} data-id="element-218" data-mp="25r6dbpuj90cg">
      {eyebrow && <p className="mb-3 text-sm font-semibold uppercase tracking-[0.18em] text-clay-600" data-id="element-219" data-mp="25p3rzj4brve2">
          {eyebrow}
        </p>}
      <h2 className="font-display text-3xl font-semibold leading-tight tracking-tight text-forest-800 sm:text-4xl md:text-[2.75rem]" data-id="element-220" data-mp="1vs8th081xuzs">
        {title}
      </h2>
      {subtitle && <p className="mt-4 text-base leading-relaxed text-forest-700/70 sm:text-lg" data-id="element-221" data-mp="1ms2ch4d5acvv">
          {subtitle}
        </p>}
    </div>;
}